import type { DefaultOptionType } from 'antd/es/select';

export const filterOptionByLabel = (
  input: string,
  option: DefaultOptionType | undefined
) =>
  ((option?.label ?? '') as string).toLowerCase().includes(input.toLowerCase());
